import { render } from "./FavoriteProducts.vue?vue&type=template&id=abe49ab2&scoped=true"
import script from "./FavoriteProducts.vue?vue&type=script&lang=js"
export * from "./FavoriteProducts.vue?vue&type=script&lang=js"

import "./FavoriteProducts.vue?vue&type=style&index=0&id=abe49ab2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe49ab2"]])

export default __exports__